<template>
  <a-modal title="Filters" width="600px" :visible="visible" @cancel="cancel" :destroy-on-close="true" v-if="visible">
    <div class="grid">
      <b class="col-4">Event Types</b>
      <custom-select
        class="col-8"
        :multiple="true"
        :value.sync="filters.event_types"
        placeholder="Event Types"
        :options="eventTypes"
        name="name"
        optionKey="sub_type"
        :loading="loadingEventTypes"
      />

      <b class="col-4">Start Date</b>
      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.start_date"
        valueFormat="YYYY-MM-DD"
        placeholder="Start Date"
        @change="handleStartDateChange('start_date', 'end_date')"
      />

      <b class="col-4">End Date</b>
      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.end_date"
        valueFormat="YYYY-MM-DD"
        placeholder="End Date"
        ref="endDatePicker"
        @change="handleEndDateChange('start_date', 'end_date')"
        :open="isEndDatePickerOpen"
        :default-picker-value="getEndDateDefaultPickerValue('start_date')"
        @openChange="handleEndDateOpenChange"
      />
    </div>

    <template slot="footer">
      <div class="flex justify-content-end">
        <a-button type="danger" :disabled="isEmptyFilters" @click="reset"> Reset </a-button>
        <a-button type="primary" @click="apply"> Apply </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { Button, DatePicker, Modal } from 'ant-design-vue'
import CustomSelect from '@/components/ui/custom-select.vue'
import { deepCopy } from '@/utils/deep-copy'
import LinkedDateFilterMixin from '@/mixins/linkedDateFilterMixin'

const filtersBaseState = Object.freeze({
  event_types: [],
  start_date: undefined,
  end_date: undefined
})

export default {
  mixins: [LinkedDateFilterMixin],
  components: {
    'a-modal': Modal,
    'a-button': Button,
    'a-date-picker': DatePicker,
    'custom-select': CustomSelect
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    currentFilters: {
      type: Object,
      required: true
    },
    eventTypes: {
      type: Array,
      default: () => []
    },
    loadingEventTypes: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filters: { ...filtersBaseState }
    }
  },
  computed: {
    isEmptyFilters() {
      return JSON.stringify(filtersBaseState) === JSON.stringify(this.filters)
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.filters = {
            ...filtersBaseState,
            ...deepCopy(this.currentFilters),
            event_types: [...(this.currentFilters.event_types ?? [])]
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      if (this.isEmptyFilters) {
        this.cancel()
      } else {
        this.filters = deepCopy(filtersBaseState)
        this.$emit('update:currentFilters', this.filters)
      }
    },
    cancel() {
      this.$emit('update:visible', false)
    },
    apply() {
      this.cancel()
      this.$emit('update:currentFilters', this.filters)
    }
  }
}
</script>

<style scoped>
.ant-calendar-picker {
  margin: 0;
}
</style>
